import { PlusOutlined } from '@ant-design/icons';
import { Button, Card, Divider, Input, Select, Space, Table, TablePaginationConfig } from 'antd';
import { useCallback, useEffect, useState } from 'react';
import { API } from '../../../api';
import { PagedResultState } from '../../../common/CommonResult';
import queryString from 'query-string';
import { Link, useLocation, useNavigate } from 'react-router-dom';

interface Filter {
  query?: string;
  branchType?: any;
}

const BranchList = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [filter, setFilter] = useState<Filter>({});
  const [state, setState] = useState<PagedResultState<any>>({
    loading: true,
    result: {},
  });

  useEffect(() => {
    if (location.search) {
      fetchData();
    }
  }, [location.search]);

  useEffect(() => {
    if (!location.search) {
      navigate(`/settings/branch?page=1&size=10`);
    }
  }, [location]);

  const fetchData = useCallback(async () => {
    setState({ ...state, loading: true });
    try {
      const response = await API.get({ apiVersion: 'api' })(`/branch/list1${location.search}`);
      setState({
        loading: false,
        result: response.result,
      });
    } catch (error: any) {
      setState({ ...state, loading: true, error: true });
    }
  }, [state, location]);

  const onSearch = useCallback(() => {
    const params = queryString.parse(location.search);
    const search = {
      ...params,
      query: filter.query,
      branchType: filter.branchType,
    };
    navigate(`/settings/branch?${queryString.stringify(search)}`);
  }, [filter, location]);

  const handleTableChange = useCallback(
    (pagination: TablePaginationConfig) => {
      const params = queryString.parse(location.search);
      const search = {
        ...params,
        page: pagination.current || 1,
        size: pagination.pageSize || 10,
      };
      navigate(`/settings/branch?${queryString.stringify(search)}`);
    },
    [location]
  );

  const columns = [
    {
      title: 'Код',
      dataIndex: 'cd',
      key: 'cd',
    },
    {
      title: 'Салбарын нэр',
      key: 'name',
      render: (record: any) => {
        return <Link to={`/settings/branch/update/${record.no}`}>{record.name}</Link>;
      },
    },
    {
      title: 'Салбарын нэр(en)',
      dataIndex: 'nameEn',
      key: 'nameEn',
    },
    {
      title: 'Утас 1',
      dataIndex: 'phone1',
      key: 'phone1',
    },
    {
      title: 'Утас 2',
      dataIndex: 'phone2',
      key: 'phone2',
    },
    {
      title: 'Хаяг',
      dataIndex: 'addressDetail',
      key: 'addressDetail',
      width: 300,
    },
    {
      title: 'Хариуцах хаяг',
      width: 150,
      render: (record: any) => {
        return (
          <Link to={`/settings/branch/address/${record.no}`}>
            <Button size="small">Харах</Button>
          </Link>
        );
      },
    },
  ];

  return (
    <Card
      title={`Салбарууд - ${state.result?.total || 0}`}
      extra={
        <Link to={`/settings/branch/create`}>
          <Button type="primary" icon={<PlusOutlined />}>
            Салбар нэмэх
          </Button>
        </Link>
      }
    >
      <Space style={{ marginBottom: 16 }}>
        <Select style={{ width: 100 }} onChange={(e) => setFilter({ ...filter, branchType: e })}>
          <Select.Option value="BRANCH">Салбар</Select.Option>
          <Select.Option value="BOX">Локер</Select.Option>
        </Select>
        <Input.Search
          value={filter.query}
          placeholder="хайх"
          onChange={(e) => setFilter({ ...filter, query: e.target.value })}
          onSearch={onSearch}
        />
      </Space>
      <Table
        size="small"
        bordered
        loading={state.loading}
        dataSource={state.result?.data || []}
        rowKey={'id'}
        pagination={{
          current: state?.result?.page || 1,
          size: 'small',
          pageSize: state?.result?.size || 10,
          total: state?.result?.total,
        }}
        onChange={handleTableChange}
        columns={columns}
      />
    </Card>
  );
};

export default BranchList;
